import React, { useState, useEffect } from 'react';
import { Table, Form, Select, Button, message, DatePicker, Modal, Input, Tabs, Drawer, Space,Row,Col } from 'antd';
import { ticketService } from '../../services/ticket.service';
import { userService } from '../../services/user.service';
import { valveService } from '../../services/valve.service';
import dayjs from 'dayjs';
import FilterForm from '../../components/FilterForm';

function Tickets() {
  const [currentPage, setCurrentPage] = useState(1);
  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [userNames, setUserNames] = useState([]);
  const [creatorNames, setCreatorNames] = useState([]);
  const [isExportModalVisible, setIsExportModalVisible] = useState(false);
  const [exportFileName, setExportFileName] = useState('');
  const [activeStatus, setActiveStatus] = useState(1); // 默认显示处理中的工单
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [currentValve, setCurrentValve] = useState(null);
  const pageSize = 10;

  const statusTabs = [
    { key: 1, label: '处理中' },
    { key: 2, label: '待审核' },
    { key: 3, label: '审核失败' },
    { key: 4, label: '已完成' },
    { key: 0, label: '已撤单' }
  ];

  const wellCoverStatusMap = {
    0: '破损',
    1: '完好'
  };

  const wellCoverLocationMap = {
    1: '机动车道',
    2: '非机动车道',
    3: '人行横道',
    4: '人行道',
    5: '绿化带',
    6: '斑马线',
    7: '泥土路面',
    8: '铺装道板'
  };

  const checkTypeMap = {
    0: '开井查验',
    1: '不开井查验'
  };

  const wellCoverAbnormalMap = {
    1: '无',
    2: 'GIS有，现场灭失',
    3: 'GIS有，现场错位',
    4: 'GIS无，现场有'
  };

  const valveSubtypeMap = {
    2: '蝶阀',
    1: '闸阀'
  };

  const valveCategoryMap = {
    1: '小区进水阀门',
    2: '小区环线阀门',
    3: '小区楼幢阀门',
    4: '小区单元阀门',
    5: '小区消火栓阀门',
    6: '小区其他',
    7: '市政管线阀门',
    8: '市政管线消防栓阀门'
  };

  const fetchNicknameOptions = async () => {
    try {
      const [assigneeResponse, creatorResponse] = await Promise.all([
        userService.fetchNicknameOptions(2),
        userService.fetchNicknameOptions([0,1])
      ]);
      if (assigneeResponse.code === 0 && creatorResponse.code === 0) {
        setUserNames(assigneeResponse.data);
        setCreatorNames(creatorResponse.data);
      } else {
        message.error('获取用户姓名列表失败');
      }
    } catch (error) {
      message.error('获取用户姓名列表失败：' + error.response?.data?.message ||  error.message);
    }
  };

  

  const fetchTickets = async (params = {}) => {
    setLoading(true);
    try {
      const response = await ticketService.getTicketList({
        page: params.page || currentPage,
        limit: pageSize,
        status: params.status || activeStatus,
        assign_id: params.assignee,
        creator_id: params.creator,
        searchparams: params.searchparams,
        create_at_start: params.createAtStart?.valueOf(),
        create_at_end: params.createAtEnd?.valueOf(),
        finish_at_start: params.finishAtStart?.valueOf(),
        finish_at_end: params.finishAtEnd?.valueOf(),
        // 添加排序参数
        sort_field: params.sortField,
        sort_order: params.sortOrder
      });
      
      if (response.code === 0) {
        setData(response.data.list.map(item => ({ ...item, key: item.ticket_id })));
        setTotal(response.data.total);
      } else {
        message.error(response.message || '获取工单列表失败');
      }
    } catch (error) {
      message.error('获取工单列表失败：' + error.response?.data?.message ||  error.message);
    } finally {
      setLoading(false);
    }
  };

  // 修改searchParams状态，包含排序参数
  const [searchParams, setSearchParams] = useState({
    page: 1,
    sortField: undefined,
    sortOrder: undefined
  });
  const [statusCount, setStatusCount] = useState({});
  
  // 统一的数据获取函数 - 需要在getColumns之前定义
  const handleTableChange = (pagination, filters, sorter) => {
    const newParams = {
      ...searchParams,
      page: pagination?.current || searchParams.page,
      sortField: sorter?.field || searchParams.sortField,
      sortOrder: sorter?.order === 'ascend' ? 'asc' : 
                 sorter?.order === 'descend' ? 'desc' : 
                 sorter?.order === undefined ? undefined : searchParams.sortOrder
    };
    
    // 如果取消排序，清除排序参数
    if (sorter && !sorter.order) {
      newParams.sortField = undefined;
      newParams.sortOrder = undefined;
    }
    
    setSearchParams(newParams);
    
    fetchTickets({
      ...newParams,
      status: activeStatus
    });
  };

  const fetchTicketsCount = async (params = {}) => {
    try {
      const response = await ticketService.getTicketCount({
        creator_id: params.creator,
        assign_id: params.assignee,
        searchparams: params.searchparams,
        create_at_start: params.createAtStart?.valueOf(),
        create_at_end: params.createAtEnd?.valueOf(),
        finish_at_start: params.finishAtStart?.valueOf(),
        finish_at_end: params.finishAtEnd?.valueOf()
      });
      
      if (response.code === 0) {
        setStatusCount(response.data.status_count);
      } else {
        message.error(response.message || '获取工单统计失败');
      }
    } catch (error) {
      message.error('获取工单统计失败：' + error.response?.data?.message ||  error.message);
    }
  };


  useEffect(() => {
    fetchTickets({ 
      status: activeStatus,
      ...searchParams,
      page: 1, // 确保使用页码1
      assignee: form.getFieldValue('assignee'),
      creator: form.getFieldValue('creator'),
      searchparams: form.getFieldValue('searchparams'),
      createAtStart: form.getFieldValue('createAtRange')?.[0]?.valueOf(),
      createAtEnd: form.getFieldValue('createAtRange')?.[1]?.valueOf(),
      finishAtStart: form.getFieldValue('finishAtRange')?.[0]?.valueOf(),
      finishAtEnd: form.getFieldValue('finishAtRange')?.[1]?.valueOf()
    });
  }, [activeStatus]);

  useEffect(() => {
    fetchNicknameOptions();
    fetchTicketsCount();
  }, []);

  // 在useEffect之前定义一个动态获取columns的函数
  const getColumns = () => {
    const baseColumns = [
      {
        title: '工单ID',
        dataIndex: 'ticket_id',
        key: 'ticket_id',
        width: 80,
      },
      {
        title: '派单人',
        dataIndex: ['ticketCreator', 'nickname'],
        key: 'ticketCreator',
        width: 100,
      },
      {
        title: '处理人',
        dataIndex: ['ticketAssignee', 'nickname'],
        key: 'ticketAssignee',
        width: 100,
      },
      {
        title: '阀门ID',
        dataIndex: 'valve_id',
        key: 'valve_id',
        render: (valve_id) => valve_id === -9999 ? '外业新增阀门' : valve_id,
        width: 100,
      },
      {
        title: '派单时间',
        dataIndex: 'created_at',
        key: 'created_at',
        render: (text) => new Date(text).toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }),
        width: 180
      },
    ];
    
    // 如果是待审核状态，添加提交时间列
    if (activeStatus === 2 || activeStatus === 3 || activeStatus === 4) {
      baseColumns.push({
        title: '外业提交时间',
        dataIndex: 'finish_at',
        key: 'finish_at',
        width: 180,
        sorter: true, // 启用排序
        render: (text) => text ? new Date(text).toLocaleString('zh-CN', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }) : '-'
      });
    }
    
    
    // 添加操作列
    baseColumns.push({
      title: '操作',
      key: 'action',
      width: 100,
      render: (_, record) => (
        <Space>
          {record.status === 2 && (
            <Button type="link" onClick={() => {
              setCurrentValve(record);
              setDrawerVisible(true);
            }}>
              去审核
            </Button>
          )}
          {record.status === 1 && (
            <Button type="link" danger onClick={() => handleCancel(record.valve_id)}>
              撤单
            </Button>
          )}
        </Space>
      ),
    });
    
    return baseColumns;
  };
  const handleCancel = (valveId) => {
    Modal.confirm({
      title: '确认撤单',
      content: '确定要撤销这个工单吗？',
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        try {
          const response = await valveService.revokeTicket(valveId);

          if (response.code === 0) {
            message.success("撤单成功");
            fetchTickets({ status: activeStatus });
            fetchTicketsCount();
          } else {
            message.error(response.message || "撤单失败");
          }
        } catch (error) {
          message.error("撤单失败：" + error.response?.data?.message || "未知错误" );
        }
      }
    });
  };

  const handleSearch = (values) => {
    const params = {
      page: 1
    };
    
    // 检查并添加状态筛选
    if (values.status !== "all" && values.status !== undefined) {
      params.status = values.status;
    }
    
    // 检查并添加外业人员筛选
    if (values.assignee) {
      params.assignee = values.assignee;
    }
    
    // 检查并添加派单人筛选
    if (values.creator) {
      params.creator = values.creator;
    }

    // 检查并添加派单人筛选
    if (values.searchparams) {
      params.searchparams = values.searchparams;
    }
    
    // 检查并添加创建时间范围筛选
    if (values.createAtRange) {
      const [createAtStart, createAtEnd] = values.createAtRange;
      params.createAtStart = createAtStart.valueOf();
      params.createAtEnd = createAtEnd.endOf('day').valueOf();
    }
    
    // 检查并添加更新时间范围筛选
    if (values.finishAtRange) {
      const [finishAtStart, finishAtEnd] = values.finishAtRange;
      params.finishAtStart = finishAtStart.valueOf();
      params.finishAtEnd = finishAtEnd.endOf('day').valueOf();
    }
    
    setSearchParams(params);
    fetchTickets(params);
    fetchTicketsCount(params);
  };

  const handleReset = () => {
    form.resetFields();
    setActiveStatus(1);
    setSearchParams({ page: 1 });
    fetchTickets({ page: 1, status: 1 });
    fetchTicketsCount({}); // 传入空对象确保不带任何筛选条件刷新TAB区域数据
  };

  const handleExport = async () => {
    if (!exportFileName.trim()) {
      message.error('请输入文件名');
      return;
    }
    setLoading(true);
    try {
      const response = await ticketService.exportTicketList({
        page: 1,
        limit: 5000,
        status: searchParams.status === null ? undefined : searchParams.status,
        creator_id: searchParams.creator,
        assign_id: searchParams.assignee,
        searchparams: searchParams.searchparams,
        create_at_start: searchParams.createAtStart,
        create_at_end: searchParams.createAtEnd,
        finish_at_start: searchParams.finishAtStart,
        finish_at_end: searchParams.finishAtEnd
      });


      // 处理导出数据
      const processedData = response.data.list.map(item => ({
        ticket_id: item.ticket_id,
        creator_nickname: item.ticketCreator?.nickname || '-',
        assignee_nickname: item.ticketAssignee?.nickname || '-',
        valve_id: item.valve_id,
        created_at: item.created_at ? new Date(item.created_at).toLocaleString('zh-CN', { 
          year: 'numeric', month: '2-digit', day: '2-digit', 
          hour: '2-digit', minute: '2-digit' 
        }) : '-',
        finish_at: item.finish_at ? new Date(item.finish_at).toLocaleString('zh-CN', { 
          year: 'numeric', month: '2-digit', day: '2-digit', 
          hour: '2-digit', minute: '2-digit' 
        }) : '-',
        status: (() => {
          switch (Number(item.status)) {
            case 0: return '已撤单';
            case 1: return '处理中';
            case 2: return '待审核';
            case 3: return '审核失败';
            case 4: return '已完成';
            default: return '未知';
          }
        })()
      }));

      // 创建工作表
      const XLSX = require('xlsx');
      const ws = XLSX.utils.json_to_sheet(processedData);

      // 设置列宽
      const colWidths = [
        { wch: 10 },  // 工单ID
        { wch: 15 },  // 创建人
        { wch: 15 },  // 指派人
        { wch: 10 },  // 阀门ID
        { wch: 20 },  // 派单时间
        { wch: 20 },  // 完成时间
        { wch: 10 }   // 状态
      ];
      ws['!cols'] = colWidths;

      // 设置表头
      XLSX.utils.sheet_add_aoa(ws, [[
        '工单ID', '创建人', '指派人', '阀门ID',
        '派单时间', '外业提交时间', '状态'
      ]], { origin: 'A1' });

      // 创建工作簿并导出
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '工单列表');
      XLSX.writeFile(wb, `${exportFileName}.xlsx`);
      setIsExportModalVisible(false);
      setExportFileName('');
      message.success('导出成功');
    } catch (error) {
      message.error('导出失败：' + error.response?.data?.message ||  error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ margin: 0 }}>工单管理</h2>
        <Button type="primary" onClick={() => setIsExportModalVisible(true)}>导出Excel</Button>
      </div>
      
      <FilterForm
          onFinish={handleSearch}
          onReset={handleReset}
          form={form}
        >
          <Form.Item span="2" name="createAtRange" label="派单时间" style={{ flex: '1 1 300px', marginBottom: '10px' }}>
            <DatePicker.RangePicker 
              style={{ width: '100%' }}
              onChange={(dates) => {
                if (dates) {
                  form.setFieldsValue({
                    createAtRange: dates
                  });
                }
              }}
            />
          </Form.Item>
          <Form.Item span="2" name="finishAtRange" label="外业提交时间" style={{ flex: '1 1 300px', marginBottom: '10px' }}>
            <DatePicker.RangePicker 
              style={{ width: '100%' }}
              onChange={(dates) => {
                if (dates) {
                  form.setFieldsValue({
                    finishAtRange: dates
                  });
                }
              }}
            />
          </Form.Item>
          <Form.Item name="assignee" label="处理人" style={{ flex: '1 1 200px', marginBottom: '10px', maxWidth: '300px'}}>
            <Select placeholder="请选择处理人" allowClear style={{ width: '100%' }}>
              {userNames.map(user => (
                <Select.Option key={user.id} value={user.id}>{user.nickname}</Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="creator" label="派单人" style={{ flex: '1 1 200px', marginBottom: '10px', maxWidth: '300px'}}>
            <Select placeholder="请选择派单人" allowClear style={{ width: '100%' }}>
              {creatorNames.map(user => (
                <Select.Option key={user.id} value={user.id}>{user.nickname}</Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="searchparams" label="高级搜索" style={{ flex: '1 1 200px', marginBottom: '10px', maxWidth: '300px'}}>
            <Input placeholder="请输入地址/GIS流水号/井盖编号" />
          </Form.Item>
          
        </FilterForm>
      <div style={{ marginBottom: '20px' }}>
        <Tabs
          activeKey={activeStatus.toString()}
          onChange={(key) => {
            setActiveStatus(Number(key));
          }}
          items={statusTabs.map(tab => ({
            key: tab.key.toString(),
            label: `${tab.label}${statusCount[tab.key] !== undefined ? ` (${statusCount[tab.key]})` : ''}`
          }))}
        />
      </div>
      <div style={{ marginTop: '20px' }}>
        <Table
          columns={getColumns()}
          dataSource={data}  // Change from 'tickets' to 'data'
          loading={loading}
          rowKey="id"
          scroll={{ x: 1200 }}
          onChange={handleTableChange}
          pagination={{
            current: searchParams.page,
            pageSize: pageSize,
            total: total,
          }}
        />
      </div>
      <Modal
        title="导出Excel"
        open={isExportModalVisible}
        onOk={handleExport}
        onCancel={() => {
          setIsExportModalVisible(false);
          setExportFileName('');
        }}
        confirmLoading={loading}
      >
        <Form.Item label="文件名" required>
          <Input
            placeholder="请输入文件名"
            value={exportFileName}
            onChange={(e) => setExportFileName(e.target.value)}
          />
        </Form.Item>
      </Modal>
      <Drawer
        title={
          <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
            工单详情审核
          </div>
        }
        placement="right"
        width={600}
        onClose={() => {
          setDrawerVisible(false);
          setCurrentValve(null);
        }}
        open={drawerVisible}
        styles={{ body: { padding: '16px', backgroundColor: '#f9f9f9' } }}
      >
        {currentValve && (
          <div>
            <div>
              {currentValve.collection_data && (
                <>
                  {/* 位置信息区域 */}
                  <div style={{ 
                    marginBottom: '12px', 
                    backgroundColor: 'white', 
                    padding: '16px', 
                    borderRadius: '12px',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                  }}>
                    <div style={{ 
                      borderBottom: '1px solid #f0f0f0', 
                      paddingBottom: '4px', 
                      marginBottom: '8px',
                      fontWeight: 'bold',
                      fontSize: '16px',
                      color: '#1890ff'
                    }}>
                      <span>位置信息</span>
                    </div>
                    <Row gutter={16}>
                      <Col span={12}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>普查日期：</strong>{currentValve.collection_data.pc_date ? dayjs(currentValve.collection_data.pc_date).format('YYYY-MM-DD') : '-'}</p>
                      </Col>
                      <Col span={12}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>所属区域：</strong>{currentValve.collection_data.district || '-'}</p>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={24}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>地址：</strong>{currentValve.collection_data.address || '-'}</p>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={8}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>X坐标：</strong>{currentValve.collection_data.geometry_x || '-'}</p>
                      </Col>
                      <Col span={8}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>Y坐标：</strong>{currentValve.collection_data.geometry_y || '-'}</p>
                      </Col>
                      <Col span={8}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>Z坐标：</strong>{currentValve.collection_data.geometry_z || '-'}</p>
                      </Col>
                    </Row>
                  </div>

                  {/* 阀门信息区域 */}
                  <div style={{ 
                    marginBottom: '12px', 
                    backgroundColor: 'white', 
                    padding: '16px', 
                    borderRadius: '12px',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                  }}>
                    <div style={{ 
                      borderBottom: '1px solid #f0f0f0', 
                      paddingBottom: '4px', 
                      marginBottom: '8px',
                      fontWeight: 'bold',
                      fontSize: '16px',
                      color: '#1890ff'
                    }}>
                      <span>阀门信息</span>
                    </div>
                    <Row gutter={16}>
                      <Col span={12}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>阀门状态：</strong>
                          <span style={{ 
                            color: currentValve.collection_data.fmzt === 1 ? '#52c41a' : currentValve.collection_data.fmzt === 0 ? '#f5222d' : '#666'
                          }}>
                            {currentValve.collection_data.fmzt === 1 ? '正常' : currentValve.collection_data.fmzt === 0 ? '异常' : '-'}
                          </span>
                        </p>
                        {currentValve.collection_data.fmzt === 0 && (
                          <p style={{ margin: '8px 0', color: '#f5222d' }}><strong style={{ color: '#666' }}>异常原因：</strong>{currentValve.collection_data.abnormal_reason || '-'}</p>
                        )}
                      </Col>
                      <Col span={12}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>阀门类型：</strong>{valveSubtypeMap[currentValve.collection_data.subtype] || '-'}</p>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={12}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>阀门深度：</strong>{currentValve.collection_data.depth ? `${currentValve.collection_data.depth}米` : '-'}</p>
                      </Col>
                      <Col span={12}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>阀门类别：</strong>{valveCategoryMap[currentValve.collection_data.category] || '-'}</p>
                      </Col>
                      <Col span={12}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>阀门口径：</strong>DN{currentValve.collection_data.standard}</p>
                      </Col>
                    </Row>
                  </div>
                  
                  {/* 井盖信息区域 */}
                  <div style={{ 
                    marginBottom: '12px', 
                    backgroundColor: 'white', 
                    padding: '16px', 
                    borderRadius: '12px',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                  }}>
                    <div style={{ 
                      borderBottom: '1px solid #f0f0f0', 
                      paddingBottom: '4px', 
                      marginBottom: '8px',
                      fontWeight: 'bold',
                      fontSize: '16px',
                      color: '#1890ff'
                    }}>
                      <span>井盖信息</span>
                    </div>
                    <Row gutter={16}>
                      <Col span={12}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>井盖编号：</strong>{currentValve.collection_data.jgbh || '-'}</p>
                      </Col>
                      <Col span={12}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>井盖厂家：</strong>{currentValve.collection_data.jgcj || '-'}</p>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={12}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>井盖尺寸：</strong>{currentValve.collection_data.jgcc || '-'}</p>
                      </Col>
                      <Col span={12}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>井盖材质：</strong>{currentValve.collection_data.jgcz || '-'}</p>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={12}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>井盖状态：</strong>
                          <span style={{ 
                            color: currentValve.collection_data.jgzt === 1 ? '#52c41a' : currentValve.collection_data.jgzt === 0 ? '#f5222d' : '#666'
                          }}>
                            {wellCoverStatusMap[currentValve.collection_data.jgzt] || '-'}
                          </span>
                        </p>
                      </Col>
                      <Col span={12}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>井盖周边：</strong>
                          <span style={{ 
                            color: currentValve.collection_data.jgzb === 1 ? '#52c41a' : currentValve.collection_data.jgzb === 0 ? '#f5222d' : '#666'
                          }}>
                            {wellCoverStatusMap[currentValve.collection_data.jgzb] || '-'}
                          </span>
                        </p>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={12}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>井盖位置：</strong>{wellCoverLocationMap[currentValve.collection_data.jgwz] || '-'}</p>
                      </Col>
                      <Col span={12}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>查验类别：</strong>{checkTypeMap[currentValve.collection_data.cylb] || '-'}</p>
                      </Col>
                    </Row>
                    <Row gutter={16}>
                      <Col span={24}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>井盖异常描述：</strong>{wellCoverAbnormalMap[currentValve.collection_data.jgycms] || '-'}</p>
                      </Col>
                    </Row>
                  </div>

                  {/* 照片信息区域 */}
                  <div style={{ 
                    marginBottom: '12px', 
                    backgroundColor: 'white', 
                    padding: '16px', 
                    borderRadius: '12px',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                  }}>
                    <div style={{ 
                      borderBottom: '1px solid #f0f0f0', 
                      paddingBottom: '4px', 
                      marginBottom: '8px',
                      fontWeight: 'bold',
                      fontSize: '16px',
                      color: '#1890ff'
                    }}>
                      <span>照片信息</span>
                    </div>
                    <Row gutter={16}>
                      <Col span={12}>
                        {currentValve.collection_data.jg_pic_near && (
                          <div>
                            <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>井内近景照片：</strong></p>
                            <div style={{ 
                              border: '1px solid #e0e0e0',
                              backgroundColor: '#f2f2f2',
                              borderRadius: '4px', 
                              overflow: 'hidden',
                              marginTop: '8px', 
                              height:'200px', 
                              width:'100%'
                            }}>
                              <img src={currentValve.collection_data.jg_pic_near} alt="井内近景" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                            </div>
                          </div>
                        )}
                      </Col>
                      <Col span={12}>
                        {currentValve.collection_data.jg_pic_far && (
                          <div>
                            <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>井盖远景照片：</strong></p>
                            <div style={{ 
                              border: '1px solid #e0e0e0',
                              backgroundColor: '#f2f2f2',
                              borderRadius: '4px', 
                              overflow: 'hidden',
                              marginTop: '8px', 
                              height:'200px', 
                              width:'100%'
                            }}>
                              <img src={currentValve.collection_data.jg_pic_far} alt="井内远景" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                            </div>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </div>

                  {/* 备注信息区域 */}
                  <div style={{ 
                    marginBottom: '12px', 
                    backgroundColor: 'white', 
                    padding: '16px', 
                    borderRadius: '12px',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                  }}>
                    <div style={{ 
                      borderBottom: '1px solid #f0f0f0', 
                      paddingBottom: '4px', 
                      marginBottom: '8px',
                      fontWeight: 'bold',
                      fontSize: '16px',
                      color: '#1890ff'
                    }}>
                      <span>备注信息</span>
                    </div>
                    <Row gutter={16}>
                      <Col span={24}>
                        <p style={{ margin: '8px 0' }}><strong style={{ color: '#666' }}>备注：</strong>{currentValve.collection_data.memo || '-'}</p>
                      </Col>
                    </Row>
                  </div>
                </>
              )}
            </div>
            
            {/* 审核操作区域 */}
            <div style={{ 
              marginTop: '20px', 
              backgroundColor: 'white', 
              padding: '16px', 
              borderRadius: '8px',
              boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
            }}>
              <div style={{ 
                borderBottom: '1px solid #f0f0f0', 
                paddingBottom: '8px', 
                marginBottom: '16px',
                fontWeight: 'bold',
                fontSize: '16px',
                color: '#1890ff'
              }}>
                <span>审核操作</span>
              </div>
              <Form.Item label="审核备注" style={{ marginTop: '20px' }}>
                <Input.TextArea
                  placeholder="请输入审核备注"
                  rows={4}
                  value={currentValve?.memo || ''}
                  onChange={(e) => setCurrentValve(prev => ({ ...prev, memo: e.target.value }))}
                />
              </Form.Item>
              <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                <Space>
                  <Button danger onClick={() => {
                    if (!currentValve?.memo?.trim()) {
                      message.error('请填写审核备注');
                      return;
                    }
                    Modal.confirm({
                      title: '确认审核不通过',
                      content: '确定要将此工单审核为不通过吗？',
                      okText: '确认',
                      cancelText: '取消',
                      onOk: async () => {
                        try {
                          const userResult = await userService.verifyUser();
                          if (!userResult.success) {
                            message.error('获取用户信息失败');
                            return;
                          }
                          const response = await ticketService.auditTicket(userResult.data.userId, currentValve.ticket_id, 3, currentValve.memo);
                          if (response.code === 0) {
                            message.success('审核不通过');
                            setDrawerVisible(false);
                            setCurrentValve(null);
                            fetchTickets({ 
                              status: activeStatus,
                              page: searchParams.page,
                              sortField: searchParams.sortField,
                              sortOrder: searchParams.sortOrder,
                              // 获取当前表单中的筛选条件
                              assignee: form.getFieldValue('assignee'),
                              creator: form.getFieldValue('creator'),
                              searchparams: form.getFieldValue('searchparams'),
                              createAtStart: form.getFieldValue('createAtRange')?.[0]?.valueOf(),
                              createAtEnd: form.getFieldValue('createAtRange')?.[1]?.valueOf(),
                              finishAtStart: form.getFieldValue('finishAtRange')?.[0]?.valueOf(),
                              finishAtEnd: form.getFieldValue('finishAtRange')?.[1]?.valueOf()
                            });
                            fetchTicketsCount(
                              {
                                assignee: form.getFieldValue('assignee'),
                                creator: form.getFieldValue('creator'),
                                searchparams: form.getFieldValue('searchparams'),
                                createAtStart: form.getFieldValue('createAtRange')?.[0]?.valueOf(),
                                createAtEnd: form.getFieldValue('createAtRange')?.[1]?.valueOf(),
                                finishAtStart: form.getFieldValue('finishAtRange')?.[0]?.valueOf(),
                                finishAtEnd: form.getFieldValue('finishAtRange')?.[1]?.valueOf()
                              }
                            );
                          } else {
                            message.error(response.message || '审核失败');
                          }
                        } catch (error) {
                          message.error('审核失败：' + error.response?.data?.message ||  error.message);
                        }
                      }
                    });
                  }}>不通过</Button>
                  <Button type="primary" onClick={() => {
                    Modal.confirm({
                      title: '确认审核通过',
                      content: '确定要将此工单审核为通过吗？',
                      okText: '确认',
                      cancelText: '取消',
                      onOk: async () => {
                        try {
                          const userResult = await userService.verifyUser();
                          if (!userResult.success) {
                            message.error('获取用户信息失败');
                            return;
                          }
                          const response = await ticketService.auditTicket(userResult.data.userId, currentValve.ticket_id, 4, currentValve.memo);
                          if (response.code === 0) {
                            message.success('审核通过');
                            setDrawerVisible(false);
                            setCurrentValve(null);
                            fetchTickets({ 
                              status: activeStatus,
                              page: searchParams.page,
                              sortField: searchParams.sortField,
                              sortOrder: searchParams.sortOrder,
                              // 获取当前表单中的筛选条件
                              assignee: form.getFieldValue('assignee'),
                              creator: form.getFieldValue('creator'),
                              searchparams: form.getFieldValue('searchparams'),
                              createAtStart: form.getFieldValue('createAtRange')?.[0]?.valueOf(),
                              createAtEnd: form.getFieldValue('createAtRange')?.[1]?.valueOf(),
                              finishAtStart: form.getFieldValue('finishAtRange')?.[0]?.valueOf(),
                              finishAtEnd: form.getFieldValue('finishAtRange')?.[1]?.valueOf()
                            });
                            fetchTicketsCount(
                              {
                                assignee: form.getFieldValue('assignee'),
                                creator: form.getFieldValue('creator'),
                                searchparams: form.getFieldValue('searchparams'),
                                createAtStart: form.getFieldValue('createAtRange')?.[0]?.valueOf(),
                                createAtEnd: form.getFieldValue('createAtRange')?.[1]?.valueOf(),
                                finishAtStart: form.getFieldValue('finishAtRange')?.[0]?.valueOf(),
                                finishAtEnd: form.getFieldValue('finishAtRange')?.[1]?.valueOf()
                              }
                            );
                          } else {
                            message.error(response.message || '审核失败');
                          }
                        } catch (error) {
                          message.error('审核失败：' + error.response?.data?.message ||  error.message);
                        }
                      }
                    });
                  }}>通过</Button>
                </Space>
              </div>
            </div>
          </div>
        )}
      </Drawer>
    </div>
  );
}

export default Tickets;